//This is for Sidebar trigger in mobile
export const IS_SIDEBAR_ACTIVE = (state, value) => {
  state.isSidebarActive = value;
};
